export const URLS = {
  SUBSCRIPTION: 'api/v1/subscription-data',
  PROFILE: 'api/v1/profile',
  GENAI: 'api/v1/genai',
  FLOW: 'api/v1/flow',
  WORKFLOW: 'api/v1/workflow',
  CONTENT_COLLECTION: 'api/v1/content-collection/subscription',
  EXECUTION: 'api/v1/flow/execution',
  PROCESS: 'api/v1/process',
  UPLOAD_FILE: 'api/v1/file/upload',
  DELETE_FILE: 'api/v1/file/delete',
  UPDATE_FILE: 'api/v1/file/upload/update',
  EXTRACT_TEXT: 'api/v1/extract/text',
  ENTITLEMENT_OVERVIEW: 'api/v1/entitlement/overview',
  ENTITLEMENT_UPDATE: 'api/v1/entitlement',
};
